import { Allocation } from '../../services/apiVariable';
import { apiCall } from '../../services/api';

export const getSelectionList = () => new Promise((resolve, reject) => {
  apiCall({ ...Allocation.getList })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // Toast({ type: 'error', message });
      // console.log(err);
      reject(err);
    });
});

export const allocateFunds = (id, body) => new Promise((resolve, reject) => {
  Allocation.sendList.entityId = id;

  apiCall({ ...Allocation.sendList, body })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // Toast({ type: 'error', message });
      // console.log(err);
      reject(err);
    });
});

export const getAllocatedFunds = (id, currency) => new Promise((resolve, reject) => {
  Allocation.getAllocatedList.entityId = id;
  Allocation.getAllocatedList.currency = currency;

  apiCall({ ...Allocation.getAllocatedList })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // Toast({ type: 'error', message });
      // console.log(err);
      reject(err);
    });
});

export const removeAllocatedFunds = (id) => new Promise((resolve, reject) => {
  Allocation.removeAllocatedFunds.entityId = id;

  apiCall({ ...Allocation.removeAllocatedFunds })
    .then((res) => {
      resolve(res);
      if (res.status === 200) {
        resolve(res);
      }
    })
    .catch((err) => {
      // Toast({ type: 'error', message });
      // console.log(err);
      reject(err);
    });
});
